"use client";

import { LayoutGrid, Rows3 } from "lucide-react";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import type { ListView } from "./parse-list-query";

const YEAR_IN_SECONDS = 31_536_000;

/** Two buttons that choose between the news feed and the cards; the choice is kept in a cookie so the next visit shows the same view. */
export function ListViewToggle({ value, cookieName }: { value: ListView; cookieName: string }) {
  const t = useTranslations("publicBlog.view");
  const router = useRouter();
  const choose = (next: string | undefined) => {
    if (next !== "feed" && next !== "cards") return;
    document.cookie = `${cookieName}=${next}; path=/; max-age=${YEAR_IN_SECONDS}; samesite=lax`;
    router.refresh();
  };
  return (
    <ToggleGroup variant="outline" spacing={0} value={[value]} aria-label={t("label")} onValueChange={(next) => choose(next[0])}>
      <ToggleGroupItem value="feed" aria-label={t("feed")} title={t("feed")}><Rows3 /></ToggleGroupItem>
      <ToggleGroupItem value="cards" aria-label={t("cards")} title={t("cards")}><LayoutGrid /></ToggleGroupItem>
    </ToggleGroup>
  );
}
